import revive_payload_client_4sVQNw7RlN from "/www/gamefi/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/www/gamefi/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/www/gamefi/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/www/gamefi/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/www/gamefi/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/www/gamefi/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/www/gamefi/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/www/gamefi/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/www/gamefi/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import quasar_plugin_G9rpXFQbul from "/www/gamefi/.nuxt/quasar-plugin.mjs";
import provide_4gUmUdUSZU from "/www/gamefi/node_modules/nuxt-quasar-ui/dist/runtime/provide.mjs";
import chunk_reload_client_UciE0i6zes from "/www/gamefi/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/www/gamefi/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import _01_myPlugin_o2QWeGhsuN from "/www/gamefi/plugins/01.myPlugin.ts";
import _02_polyfill_yq9W0skHet from "/www/gamefi/plugins/02.polyfill.ts";
import _03_pageSpy_client_sRbuN0HxMV from "/www/gamefi/plugins/03.pageSpy.client.ts";
import _04_howler_audio_client_pCFl0ojcaH from "/www/gamefi/plugins/04.howler-audio.client.ts";
import global_error_handler_client_XvIYK0DGsY from "/www/gamefi/plugins/global-error-handler.client.ts";
import sentry_client_shVUlIjFLk from "/www/gamefi/plugins/sentry.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  quasar_plugin_G9rpXFQbul,
  provide_4gUmUdUSZU,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  _01_myPlugin_o2QWeGhsuN,
  _02_polyfill_yq9W0skHet,
  _03_pageSpy_client_sRbuN0HxMV,
  _04_howler_audio_client_pCFl0ojcaH,
  global_error_handler_client_XvIYK0DGsY,
  sentry_client_shVUlIjFLk
]